// BuildAndExportPdf.js
import { createPdf } from "./pdf/pdfBuilder";
import { renderOverview } from "./pdf/sections/overview";
import { renderInfrastructure } from "./pdf/sections/infrastructure";
import { renderinstitutionalCapacity } from "./pdf/sections//institutionalCapacity";
import { renderSanitation } from "./pdf/sections/sanitationExport";
import { renderIndicators } from "./pdf/sections/indicators";
import { logoToBase64 } from "./pdf/logoToBase64";

import { iconToBase64 } from "./pdf/iconToBase64";
import {
    faTrash,
    faPoop,
    faPoo,
    faTruck,
    faIndustry,
    faDolly,
    faRecycle,
    faWarehouse,
    faTruckMoving,
    faTruckLoading,
    faTruckPickup,
    faCartShopping,
    faTrashCan,
    faBroomBall,
    faUsers
} from "@fortawesome/free-solid-svg-icons";
import htmlConvert from "./pdf/htmlConvert";


import {
    fetchOverview,
    fetchInfrastructure,
    fetchInstitutionalCapacity,
    fetchCityName,
    fetchIndicators,
} from "./getCityData";

export async function BuildAndExportPdf({ cityId, year, request }) {

    const cityName = await fetchCityName(request,cityId) || cityId;
    
    
    const { doc, addHeader, addFooter, save } = createPdf(`City-Profile-${cityName?.city_name}-${year}.pdf`);
    const bhpeLogo = await logoToBase64("/dphe_logo.png", 40);
    const tillerLogo = await logoToBase64("/tiller_logo.png", 40);


    const startY = await addHeader({
        logo: bhpeLogo,
        project: "National Sanitation Dashboard",
        authority: "Department of Public Health Engineering (DPHE)",
        city: cityName?.city_name,
        year: year,
    });

    // Fetch
    const overview = await fetchOverview(request, cityId, year);
    const infrastructure = await fetchInfrastructure(request, cityId, year);
    const institutionalCapacity = await fetchInstitutionalCapacity(request, cityId, year);
    const indicators = await fetchIndicators(request, cityId, year);

    //overview icons
    const fsGen = await iconToBase64(faPoop, 24, "orange");
    const fsCol = await iconToBase64(faTruck, 24, "orange");
    const fsTrt = await iconToBase64(faPoo, 24, "orange");
    const fsTP = await iconToBase64(faIndustry, 24, "orange");

    const swGen = await iconToBase64(faTrashCan, 24, "#2F4B7C");
    const swCol = await iconToBase64(faDolly, 24, "#2F4B7C");
    const swTrt = await iconToBase64(faBroomBall, 24, "#2F4B7C");
    const swTP = await iconToBase64(faRecycle, 24, "#2F4B7C");
    //infrastructure icons
    const toolsDustbin = await iconToBase64(faTrash, 24, "#2F4B7C");
    const toolsTanker = await iconToBase64(faTruck, 24, "#2F4B7C");
    const toolsSts = await iconToBase64(faWarehouse, 24, "#2F4B7C");

    const toolsCompactor = await iconToBase64(faTruckMoving, 24, "orange");
    const toolsDumpTruck = await iconToBase64(faTruckLoading, 24, "orange");
    const toolsOthers = await iconToBase64(faTruckPickup, 24, "orange");
    const toolsTrolley = await iconToBase64(faCartShopping, 24, "orange");

    // Instituitional Capacity icons
    const hrOfficials = await iconToBase64(faUsers, 24, "#2F4B7C");
    const hrWC = await iconToBase64(faUsers, 24, "#2F4B7C");
    const hrPC = await iconToBase64(faUsers, 24, "#2F4B7C");
    const hrRC = await iconToBase64(faUsers, 24, "#2F4B7C");
    const hrPPC = await iconToBase64(faUsers, 24, "#2F4B7C");

    // }

    const donutBase64 = await htmlConvert("overview-donut-chart");
    const feacalSludgeBase64 = await htmlConvert("Feacal_Sludge");
    const solidWasteBase64 = await htmlConvert("Solid_Waste");
    const containmentOutletBase64 = await htmlConvert("containment_outlet");
    const sfdBasae64 = await htmlConvert("sfd-img");


    // Render
    let lastY = renderOverview(doc, overview, { fsGen, fsCol, fsTrt, fsTP, swGen, swCol, swTrt, swTP }, donutBase64, startY);
    doc.addPage();
    lastY = renderInfrastructure(doc, infrastructure, { toolsDustbin, toolsTanker, toolsSts, toolsCompactor, toolsDumpTruck, toolsOthers, toolsTrolley }, 20);
    lastY = renderinstitutionalCapacity(doc, institutionalCapacity, { hrOfficials, hrWC, hrPC, hrRC, hrPPC }, lastY);
    lastY = renderSanitation(doc, sfdBasae64, feacalSludgeBase64, solidWasteBase64, containmentOutletBase64, lastY);
    //doc.addPage();

    lastY = renderIndicators(doc, indicators, 20);

    await addFooter(tillerLogo);
    save();
}
